<template>
    <div class="col-lg-9">
        <div class="row mb-2">
            <div class="col-lg-7">
                <h2 class="text-7 mb-1">Pay Bills</h2>
                <p class="text-2 mb-4 text-left">
                    Buy ZESA Electricity, Econet/NetOne Airtime and Bundles for multiple
                    accounts in one go!
                </p>
            </div>
            <div  class="col-lg-5">
                <div class="row d-flex flex-row-reverse">
                    <div v-for="i in corporateWallets" :key="i.id" class="col-6">
                        <router-link :to="`/business/wallet/${i.id}/view`"
                            :class="{'account-card-primary':  i.status === 'ACTIVE'}"
                            class="d-block account-card text-white rounded p-2 mb-4 mb-lg-0">
                            <small class="text-uppercase font-weight-700">{{ i.type }}</small>

                            <p class="d-flex align-items-center m-0">
                            <span class="text-uppercase font-weight-500 text-4">
                                {{money(i.balance) }}
                            </span>
                            </p>
                            <p class="text-1 text-uppercase m-0">
                                {{ i.currency }} Wallet
                            </p>
                        </router-link>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="$route.path !== '/business/transact'" class="custom-nav-container my-3">
            <ul class="custom-nav-tabs">
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link"
                                 :class="{ active: $route.path.includes('/excel') }"
                                 :to="`/business/transact/excel`">
                        Pay from Batch
                    </router-link>
                </li>
                <li class="custom-nav-item" >
                    <router-link class="custom-nav-link"
                                 :class="{ active: $route.path.includes('/form') }"
                                 :to="`/business/transact/form`">
                        Pay from Manual Input
                    </router-link>
                </li>
                <li class="custom-nav-item" >
                    <router-link class="custom-nav-link"
                                 :class="{ active: $route.path.includes('/history') }"
                                 :to="`/business/transact/history`">
                        Pay from Previous
                    </router-link>
                </li>
            </ul>

            <div class="custom-nav-underline">
                <div class="custom-nav-active-underline"
                     :style="{ left: activeTabPosition, width: activeTabWidth }">
                </div>
            </div>
        </div>
        <div class="">
            <keep-alive>
                <transition name="slide-in-left">
                    <router-view></router-view>
                </transition>
            </keep-alive>
        </div>

    </div>
</template>
<script>

import {money} from "../../../core/forms/money";

export default {
    name: "CorporateTransactionLayout",
    metaInfo: {
        title: "Pay Corporate Bills",
    },
    mixins: [money],
    data() {
        return {
            wallets: [],
            activeTabPosition: "0px",
            activeTabWidth: "0px",
        };
    },
    computed: {
        corporateWallets() {
            console.log('Wallets data:', this.wallets);
            const filtered = this.wallets.filter(wallet => wallet.type === 'Corporate');
            console.log('Filtered corporate wallets:', filtered);
            return filtered;
        }
    },
    methods: {
        fetchWallets() {
            window.axios.get('/business/wallets/list/all').then(response => {
                console.log('API Response:', response.data);
                this.wallets = response.data.body.list;
            }).catch(error => {
                console.error('Error fetching wallets:', error);
            });
        },
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        },
        initializeTooltips() {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
    },
    updated() {
        this.initializeTooltips();
    },
    watch: {
        "$route.path": function () {
            this.$nextTick(() => {
                this.updateActiveTabPosition();
            });
        }
    },
    mounted() {
        this.fetchWallets();
        this.initializeTooltips();
    }
}
</script>
